var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.withCompanyName && _vm.customer
      ? _c("h2", [_vm._v(_vm._s(_vm.companyName))])
      : _vm._e(),
    _vm._v(" "),
    _vm.isAnonymous
      ? _c(
          "div",
          { staticClass: "font-weight-extra-bold color-primary mt-2" },
          [_vm._v("Du bleibst anonym!")]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "mt-2" }, [
      _c("div", { staticClass: "font-weight-bold" }, [
        _vm._v(
          "\n\t\t\t" + _vm._s(_vm.isAnonymous ? "Anonym von " : "Von ") + " "
        ),
        _c("span", { staticClass: "color-primary" }, [
          _vm._v(_vm._s(_vm.customerName))
        ]),
        _vm._v("\n\t\t\tverabschieden:\n\t\t")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mt-2" }, [
        _vm._v(
          "\n\t\t\t" +
            _vm._s(_vm.customerName) +
            " erhält eine Nachricht, dass du nicht interessiert bist.\n\t\t"
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mt-2" }, [
      _vm._v(
        "\n\t\tVerabschiedete Jobs bzw. Unternehmen und Organisationen findest du links in der Navigation. Dort kannst du\n\t\tdiese auch wieder freischalten, solltest du deine Meinung ändern.\n\t"
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }